<script>
import { modalState, hideModal } from "@app/store/modalStore.svelte.js";
import { playerState } from "@app/store/playerStore.svelte.js";
import { projectState } from "@app/store/projectStore.svelte.js";
import { eventGroupState } from "@app/store/eventGroupStore.svelte.js";
import { authState } from "@app/store/authStore.svelte.js";
import tcLib from "@cclib/lib/timecode.js";
import incodeTime from "@cclib/lib/incodeTime.js";
import * as m from '@app/paraglide/messages.js';

let totalEvents = eventGroupState.reduce((total, eventGroup) => {
    // Add the length of the current event group's events array to the total
    return total + eventGroup.events.length;
}, 0);
</script>

<div
    class="modal fade {modalState.selected === 'projectInfo'
        ? 'show d-block'
        : ''}"
    role="dialog"
    tabindex="-1"
    id="ProjectInfoModal"
    aria-labelledby="projectInfoTitle"
    aria-describedby="projectInfoDescription">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="projectInfoTitle">{m.project_info()}</h4>
                <button
                    type="button"
                    class="btn-close"
                    aria-label={m.close_project_info_modal()}
                    onclick={hideModal}
                    id="closeProjectInfo"></button>
            </div>
            <div class="modal-body">
                <div class="table-responsive">
                <table
                    class="table table-striped"
                    id="projectInfoDescription"
                    aria-label={m.project_information_details()}>
                    <tbody>
                        <tr>
                            <th>{m.project_id_label()}</th>
                            <td>{projectState.id}</td>
                        </tr>
                        <tr>
                            <th>{m.project_name_label()}</th>
                            <td>{projectState.name}</td>
                        </tr>
                        <tr>
                            <th>{m.project_description_label()}</th>
                            <td>{projectState.description || m.no_description()}</td>
                        </tr>
                        <tr>
                            <th>{m.frame_rate()}</th>
                            <td>{projectState.frameRate}</td>
                        </tr>
                        <tr>
                            <th>{m.drop_frame()}</th>
                            <td>{projectState.dropFrame}</td>
                        </tr>
                        <tr>
                            <th>{m.incode()}</th>
                            <td
                                >{incodeTime.mediaSecondsToIncodeLabel(
                                    projectState.incode,
                                    projectState.frameRate,
                                    projectState.dropFrame,
                                )}</td>
                        </tr>
                        <tr>
                            <th>{m.incode_seconds()}</th>
                            <td>{projectState.incode}</td>
                        </tr>
                        <tr>
                            <th>{m.duration()}</th>
                            <td
                                >{tcLib.secToTc(
                                    playerState.duration,
                                    projectState.frameRate,
                                    projectState.dropFrame,
                                )}</td>
                        </tr>
                        <tr>
                            <th>{m.media_source()}</th>
                            <td>{projectState?.media?.storage}</td>
                        </tr>
                        <tr>
                            <th>{m.media_local_path()}</th>
                            <td>{projectState?.media?.localPath}</td>
                        </tr>
                        <tr>
                            <th>{m.media_path()}</th>
                            <td>{projectState?.media?.path}</td>
                        </tr>
                        <tr>
                            <th>{m.peaks_info_path()}</th>
                            <td>{projectState?.media?.peaksPath}</td>
                        </tr>
                        <tr>
                            <th>{m.media_name()}</th>
                            <td>{projectState?.media?.name}</td>
                        </tr>
                        <tr>
                            <th>{m.aspect_ratio()}</th>
                            <td>{projectState?.media?.aspectRatio}</td>
                        </tr>
                        <tr>
                            <th>{m.media_type()}</th>
                            <td>{projectState?.media?.type}</td>
                        </tr>
                        <tr>
                            <th>{m.event_groups()}</th>
                            <td>{eventGroupState.length}</td>
                        </tr>
                        <tr>
                            <th>{m.total_event()}</th>
                            <td>{totalEvents}</td>
                        </tr>
                        <tr>
                            <th>{m.subscription_status()}</th>
                            <td>{authState.status}</td>
                        </tr>
                        <tr>
                            <th>{m.subscription_owner()}</th>
                            <td>{authState.owner}</td>
                        </tr>
                        <tr>
                            <th>{m.compare_track()}</th>
                            <td>{projectState.compare}</td>
                        </tr>
                        <tr>
                            <th>{m.team_project_id()}</th>
                            <td>{projectState.teamId}</td>
                        </tr>
                        <tr>
                            <th>{m.root()}</th>
                            <td>{projectState.rootDir}</td>
                        </tr>
                        <tr>
                            <th>{m.folder_id()}</th>
                            <td>{projectState.folderId}</td>
                        </tr>
                        <tr>
                            <th>{m.use_local_storage()}</th>
                            <td>{projectState.useLocalStorage ? m.yes() : m.no()}</td>
                        </tr>
                        <tr>
                            <th>{m.local_path()}</th>
                            <td>{projectState.localPath}</td>
                        </tr>
                    </tbody>
                </table>
                </div>
            </div>
        </div>
    </div>
</div>
